import {createGrid} from "../../helpers/grids/grids";
import {loading, stopLoading} from "../../helpers/loading";
import createElement from "../../helpers/createElement";
import {createCellRenderer, createDoubleClickHandler,} from "../../helpers/grids/helpers";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {createModal} from "../../helpers/modal";
import {getLinkifiedPublicId, getLinkifiedText} from "../../helpers/linkifyContent";

function initAdminVoeOrdersIndex() {
	const historyModal = createModal({})
	let voeOrdersFilterSelect = document.querySelector('.voe-orders-grid-filter-select');

	// noinspection DuplicatedCode
	const grid = createGrid('.orders-grid', {
			columnDefs: [
				{
					field: "public_id",
					headerName: 'Order Id',
					tooltipField: 'public_id',
					cellRenderer: createCellRenderer(params => {
						const detailUrl = params.data.detailUrl
						const public_id = params.data.public_id
						return getLinkifiedPublicId({detailUrl, public_id})
					}),
				},
				{
					field: "voe_company_name",
					headerName: 'Company',
					sortable: false,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const detailUrl = params.data.voeCompanyDetailUrl
						// noinspection JSUnresolvedVariable
						const name = params.data.voe_company_name
						if (detailUrl && name) {
							return getLinkifiedText(detailUrl, name)
						}
						return '<span class="text-muted">Unassigned</span>';
					})
				},
				{
					field: "applicant_full_name",
					headerName: 'Applicant',
					sortable: false,
				},
				{
					field: "status_label",
					headerName: 'Status',
					sortable: false,

				},
				{
					field: "assigned_to_full_name",
					headerName: 'Assigned To',
					sortable: false,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						return params.data.assigned_to_full_name ?
							params.data.assigned_to_full_name :
							createElement('<span class="text-muted">On Queue</span>');
					})
				},
				{
					field: "assigned_to_user_at",
					headerName: 'Assigned At',
					sortable: true,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						return params.data.assigned_to_user_at ?
							params.data.assigned_to_user_at :
							createElement('<span class="text-muted">On Queue</span>');
					})
				},
				{
					field: "timeInQueue",
					headerName: 'Total Time',
					sortable: true,
					sort: 'desc',
				},
				{
					field: "public_id",
					headerName: '',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const processRoute = params.data.processUrl;
						// noinspection JSUnresolvedVariable
						const detailRoute = params.data.detailUrl;
						// noinspection JSUnresolvedVariable
						const historyModalRoute = params.data.historyModalRoute;

						const buttons = createElement(`
							<div class="buttons">
								<button class="btn btn-primary btn-sm view-history-button">
									<i class="fa-solid fa-clock-rotate-left"></i>
									View History
								</button>
                                <a
                                	class="btn btn-primary btn-sm" href="${detailRoute}"
                                >
                                    <i class="fa-solid fa-eye"></i>
                                    View
								</a>
                                <a
                                	class="btn btn-primary btn-sm ${!processRoute ? 'disabled' : ''}" href="${processRoute}"

                                >
                                    <i class="fa-solid fa-file-import"></i>
                                    Process Order
								</a>
                            </div>
						`);


						buttons.querySelector('.view-history-button')
							.onclick = () => handleHistoryModalRequest(historyModalRoute)

						return buttons;
					})
				},
			],

			onRowDoubleClicked: createDoubleClickHandler(data => {
				// noinspection JSUnresolvedVariable
				if (data.processUrl) {
					loading();
					window.location.href = data.processUrl
				}
			}),

			rowClass: 'cursor-pointer',
			paginationPageSize: 20,
			_rowName: 'Orders',
			_autoRefresh: true,
		},
		window['routes/admin.voe-orders.pending.grid'],
		() => {
			return {
				voeOrderStatus: voeOrdersFilterSelect.value
			}
		}
	);

	voeOrdersFilterSelect.onchange = () => grid._refresh()

	function handleHistoryModalRequest(historyModalRoute) {
		loading();

		Axios.get(historyModalRoute)
			.then(response => {
				// Display modal
				const modal = createElement(response.data.modal);

				historyModal.replace(modal);

				// Wait a bit to give time to loading overlay to hide
				setTimeout(() => historyModal.display(), 128);
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initAdminVoeOrdersIndex}
